import React, { useState } from "react";
import "./cover.css";
import background from "../../assets/imgs/background.png";
import { TypeAnimation } from "react-type-animation";

// actual background (the very first layer of the website that contains name and background)
function Cover() {
  const [completedTyping, setCompletedTyping] = useState(false);
  const titleDisplayMessage = "Mishty Bansal";
  const subtitleDisplayMessage = "DEVELOPER AND DESIGNER";

  return (
    <div style={{ zIndex: 1, position: "relative" }}>
      <div
        className="cover-main"
        style={{
          backgroundSize: "cover",
          backgroundImage: `url(${background})`,
          backgroundPosition: "center center",
        }}
      >
        <div className="cover-contents">
          {!completedTyping && (
            <TypeAnimation
              className="intro-title"
              sequence={[
                `Mishty Bansal`,
                2000,
                `Developer and Designer`,
                1000,
                () => setCompletedTyping(true),
              ]}
              wrapper="span"
              cursor={true}
            />
          )}

          {completedTyping && (
            <>
              <h1 className="intro-title">{titleDisplayMessage}</h1>
              <h3 className="intro-subtitle">{subtitleDisplayMessage}</h3>
            </>
          )}
        </div>
      </div>
      {/* for faded cover effect */}
      <div className="faded-bottom"></div>
    </div>
  );
}

export default Cover;
